"use client";

import { Check } from "lucide-react";
import { useIntl } from "react-intl";
import PersonalizedDemoWebsiteForm from "./PersonalizedDemoWebsiteForm";
import { usePricingJourney } from "@/modules/payment/components/PricingJourneyContext";

export default function PricingPersonalizedDemoCTA() {
  const intl = useIntl();
  const pricingJourney = usePricingJourney();
  if (pricingJourney.intent === "PRODUCTION_ACTIVATION") return null;

  const features = [
    intl.formatMessage({
      id: "pricing.demo.feature.website",
      defaultMessage: "An Agent prepared from your website",
    }),
    intl.formatMessage({
      id: "pricing.demo.feature.test",
      defaultMessage: "A real chatbot you can try",
    }),
    intl.formatMessage({
      id: "pricing.demo.feature.share",
      defaultMessage: "A link ready to share with your team",
    }),
  ];

  return (
    <article className="flex h-full flex-col rounded-[1.75rem] border border-indigo-200 bg-indigo-50/60 p-6 sm:p-7">
      <h2 className="text-2xl font-semibold tracking-tight text-slate-950">
        {intl.formatMessage({
          id: "pricing.demo.card.title",
          defaultMessage: "Personalized demo",
        })}
      </h2>
      <div className="mt-6">
        <p className="text-4xl font-semibold tracking-tight text-indigo-700">
          {intl.formatMessage({
            id: "pricing.demo.card.free",
            defaultMessage: "Free",
          })}
        </p>
        <p className="mt-2 text-sm text-slate-600">
          {intl.formatMessage({
            id: "pricing.demo.card.noCard",
            defaultMessage: "No card required",
          })}
        </p>
      </div>
      <p className="mt-6 text-sm leading-6 text-slate-600">
        {intl.formatMessage({
          id: "pricing.demo.card.description",
          defaultMessage:
            "Try an Agent built from your website and share it with your team before going live.",
        })}
      </p>
      <div className="mt-5">
        <PersonalizedDemoWebsiteForm layout="stacked" />
        <p className="mt-3 text-xs leading-5 text-slate-500">
          {intl.formatMessage({
            id: "pricing.demo.card.boundary",
            defaultMessage:
              "A private preview to review and share. Choose a paid plan to install it on your website.",
          })}
        </p>
      </div>{" "}
      <ul className="mt-5 space-y-3 text-sm text-slate-700">
        {features.map((feature) => (
          <li key={feature} className="flex items-start gap-2">
            <Check
              className="mt-0.5 h-4 w-4 shrink-0 text-indigo-600"
              aria-hidden="true"
            />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </article>
  );
}
